<template>
    <section class="my-select-room-add _preview-section">
        <div class="section-inner">

            <div class="item-wrap">
                <div class="action-btn-wrap form_hashtag" v-if="!isShopPage">

                    <!--MySelectRoomBtn-->
                    <input
                        type="checkbox"
                        name="add-my-select-room-preview"
                        id="add-my-select-room-preview-1"
                        v-if="((showBrand && unitAndBasic) || (showBrand && adminAndBasic) || (showShowRoom && personalAndShowRoom) || (showShowRoom && unitAndShowRoom) || basicAndShowRoom || showRoomAndBasic) && sameType"
                        value=""
                        v-on:change="openModal"
                        v-bind:checked="mySelectRoomExists == true"
                        v-bind:disabled="disableMySelectRoom"
                    >
                    <label for="add-my-select-room-preview-1" class="btn_common _ghost _home-add" v-if="((showBrand && unitAndBasic) || (showBrand && adminAndBasic) || (showShowRoom && personalAndShowRoom) || (showShowRoom && unitAndShowRoom) || basicAndShowRoom || showRoomAndBasic) && sameType">
                        <div class="md_svg-icon">
                            <SvgIconShop />
                        </div>
                        <div class="ovl _add js-toast-show"></div>
                        <div class="ovl _remove js-toast-show"></div>
                        <span class="add">My Select Room 追加</span>
                        <span class="remove">My Select Room 削除</span>
                    </label>

                </div><!--/.action-btn-wrap-->
            </div>

        </div>
    </section><!--/.page-name-row-->
    <!--:::::::::::::::::::::::::::::::::::::::::::::::
        ModalMySelectRoomCheckList
    :::::::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="modal_container MySelectRoomCheckList" v-bind:class="{_open: isOpen}">
        <div class="wrap">
            <!-- Title -->
            <div class="title">
                <h3 v-if="modalList && !modalList[0].type"><span>ショップを選択してください</span></h3>
                <h3 v-if="modalList && modalList[0].type && modalList[0].type == 1"><span>ブランドを選択してください</span></h3>
                <h3 v-if="modalList && modalList[0].type && modalList[0].type == 2"><span>ショールームを選択してください</span></h3>
            </div><!-- /.Title -->
            <!-- Text -->
            <div class="text-wrap">
                <div class="inner">

                    <ul class="list_common _full" v-for="(shop, index) in modalList" v-bind:key="index">

                        <li class="item form_checkbox _all">
                            <input
                                type="checkbox"
                                name="my-select-room-add"
                                value=""
                                v-bind:id="'my-select-room-add' + index"
                                v-bind:checked="shop.my_select_room_status"
                                v-on:change="setMySelectRoom(shop)"
                            >
                            <label v-bind:for="'my-select-room-add' + index">
                                <div class="check-mark"><span></span></div>
                                <span>{{ shop.name }}</span>
                            </label>
                        </li>

                    </ul>

                    <!-- Button -->
                    <div class="button-wrap">
                        <button type="button" class="cancel" v-on:click="closeModal"><span>キャンセル</span></button>
                        <button type="button" v-bind:disabled="isDisabled" v-on:click="saveMySelectRoom"><span>OK</span></button>
                    </div><!-- /.button-wrap -->

                </div><!-- /.Inner -->
            </div><!-- /.Text -->
            <div class="close-icon"><span></span><span></span></div>
        </div><!-- /.Wrap -->
        <div class="modal_close-ovl" v-on:click="closeModal"></div>
    </div><!-- /.ModalContainer -->
    <!--:::::::::::::::::::::::::::::::::::::::::::::::
        ModalBackGround
    :::::::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="modal_bg" v-bind:class="{_on: isOpen}"></div>

</template>

<script>

    import SvgIconThumbsUp from '@/components/EndUser/svg/SvgIconThumbsUp'
    import SvgIconHomeAdd from '@/components/EndUser/svg/SvgIconHomeAdd'
    import SvgIconMovie from '@/components/EndUser/svg/SvgIconMovie'
    import SvgIconSnsFacebook from '@/components/EndUser/svg/SvgIconSnsFacebook'
    import SvgIconSnsTwitter from '@/components/EndUser/svg/SvgIconSnsTwitter'
    import SvgIconSnsInstagram from '@/components/EndUser/svg/SvgIconSnsInstagram'
    import SvgIconShop from '@/components/EndUser/svg/SvgIconShop'
    import SvgIconSnsLine from '@/components/EndUser/svg/SvgIconSnsLine'
    import likeMixins from '@/common/like.js'

    export default {
        components: {
            mixins: [likeMixins],
            SvgIconHomeAdd,
            SvgIconMovie,
            SvgIconThumbsUp,
            SvgIconSnsFacebook,
            SvgIconSnsTwitter,
            SvgIconShop,
            SvgIconSnsInstagram,
            SvgIconSnsLine,
        },
        data() {
            return {
                likeStatus: false,
                likeCount: 0,
                mySelectRoomExists: false,
                isDisabled: false,
                user: '',
                isOpen: false,
                shopsData: [],
                isDisabled: false,
            };
        },
        created() {
            if (this.$store.state.detail.set.like) {
                this.likeStatus = this.$store.state.detail.set.like.status;
                this.likeCount = this.$store.state.detail.set.like.count;
            }
            if (this.$store.state.detail.set.user) {
                this.user = this.$store.state.detail.set.user;
            }
            if (this.$store.state.detail.set.modal_list) {
                for (var i in this.$store.state.detail.set.modal_list) {
                    if (this.$store.state.detail.set.modal_list[i].my_select_room_status == true) {
                        this.shopsData.push(this.$store.state.detail.set.modal_list[i]);
                    }
                }
            }

        },
        methods: {
            setLike(value) {
                this.likeStatus = value;
                var forToast = '';
                if (value == true) {
                    this.likeCount = this.likeCount + 1;
                    forToast = 'setLike';
                } else {
                    this.likeCount = this.likeCount - 1;
                    forToast = 'unsetLike';
                }
                axios.post(route('set.like'), {
                    brand_id: this.$store.state.detail.set.brand.id,
                    like_status: this.likeStatus,
                }).then((res) => {
                    if (res.data.length == 0) {
                        location.href = '/login' + '?before';
                    } else {
                        this.$emit("toast", forToast);
                        this.likeStatus  = res.data.status;
                        this.likeCount  = res.data.count;
                        this.$store.state.detail.set.like.status = this.likeStatus;
                        this.$store.state.detail.set.like.count = this.likeCount;
                    }

                    // Local strageに保存
                    likeMixins.methods.saveLike(this.$store.state.detail.set.brand.id, this.likeStatus);

                }).catch((error) => {
                    console.log(error);
                    // if (error.response.status == 401) {
                    //     location.href = '/login' + '?before';
                    // }
                });
            },
            setMySelectRoom(shop) {
                var shopIndex = '';
                var shopCheck = true;

                this.shopsData.forEach(function(shopData, index) {
                    if (shopData.id == shop.id) {
                        shopIndex = index;
                        shopCheck = false;
                    }
                });

                if (!shopCheck){
                    this.shopsData.splice(shopIndex, 1)
                } else {
                    this.shopsData.push(shop)
                }
            },
            saveMySelectRoom() {
                this.isDisabled = true;
                if (this.showBrand) {
                    var page_type = 1;
                } else if (this.showShowRoom) {
                    var page_type = 2;
                }
                axios.post(route('set.mySelectRoom'), {
                    page_type: page_type,
                    shops: this.shopsData,
                    brand_id: this.$store.state.detail.set.brand.id,
                    basic_and_showroom: this.$store.state.detail.set.basicAndShowRoom,
                    showroom_and_basic: this.$store.state.detail.set.showRoomAndBasic,
                }).then((res) => {
                    var responseShops = [];
                    for (var i in res.shops) {
                        if (res.shops[i].my_select_room_status == true) {
                            responseShops.push(res.shops[i]);
                        }
                    }
                    this.shopsData = responseShops;
                    this.$emit("toast", 'setMySelectRoom');
                    this.closeModal();
                }).catch((error) => {
                    if (error.response.status == 401) {
                        location.href = '/login' + '?before';
                    }
                });
            },
            openModal() {
                if (!this.$store.state.detail.set.user || this.$store.state.detail.set.user.length == 0) {
                    return location.href = '/login' + '?before';
                } else {
                    this.isOpen = true;
                }
            },
            closeModal() {
                this.isOpen = false;
                this.isDisabled = false;
                location.reload();
            },
        },
        computed: {
            isShopPage() {
                var url = location.pathname;
                if (url.indexOf( 'shop' ) != -1) {
                    //ショップページの場合
                    return true;
                } else {
                    //ショップページではない場合
                    return false;
                }
            },
            disableLike() {
                var url = location.pathname;
                if (url.indexOf( '/demo/' ) != -1) {
                    return true;
                }
                if (url.indexOf( 'registration' ) != -1 || url.indexOf( 'brand/detail' ) != -1) {
                    return true;
                } else {
                    return false;
                }
            },
            disableMySelectRoom() {
                var url = location.pathname;
                if (url.indexOf( '/demo/' ) != -1) {
                    return true;
                }
                if (url.indexOf( 'registration' ) != -1) {
                    return true;
                } else {
                    return false;
                }
            },
            modalList() {
                if (this.$store.state.detail.set.modal_list) {
                    return this.$store.state.detail.set.modal_list;
                }
            },
            mySelectRoomExists() {
                if (this.shopsData.length > 0) {
                    return true;
                } else return false;
            },
            showBrand() {
                var url = location.pathname;
                return url.indexOf( '/brand' ) != -1;
            },
            showShowRoom() {
                var url = location.pathname;
                return url.indexOf( '/showroom' ) != -1;
            },
            personalAndBasic() {
                if (this.$store.state.detail.set.personalAndBasic) {
                    return true;
                }
            },
            unitAndBasic() {
                if (this.$store.state.detail.set.unitAndBasic) {
                    return true;
                }
            },
            personalAndShowRoom() {
                return this.$store.state.detail.set.personalAndShowRoom;
            },
            unitAndShowRoom() {
                return this.$store.state.detail.set.unitAndShowRoom;
            },
            basicAndShowRoom() {
                return this.$store.state.detail.set.basicAndShowRoom;
            },
            showRoomAndBasic() {
                return this.$store.state.detail.set.showRoomAndBasic;
            },
            pageType() {
                var url = location.pathname;
                if (url.indexOf( '/registration' ) != -1) {
                    //初回編集
                    return 0;
                } else if (url.indexOf( '/detail' ) != -1) {
                    //管理画面での編集
                    return 1;
                } else {
                    //エンドユーザー側での表示
                    return 2;
                }
            },
            sameType() {
                let url = location.pathname;
                if (this.user) {
                    if (this.user.type == 2 && url.indexOf( '/brand-detail' ) != -1) {
                        return false;
                    }
                    if (this.user.type == 3 && url.indexOf( '/showroom-detail' ) != -1) {
                        return false;
                    }
                    return true;
                } else {
                    return false;
                }
            },
        }
    }
</script>

